import _ from 'lodash';
import { Fetch, hashifyDictionary } from 'barnyard/utils/';
import * as constants from '../constants';


export const productsSearch = searchQuery => (dispatch) => {
  const search = hashifyDictionary(searchQuery);
  return Fetch({
    url: '/api/products/search/',
    body: searchQuery,
    success: (results) => {
      dispatch({
        type: constants.PRODUCTS_SEARCH_SUCCESS,
        results,
        query: search,
      });
    }
  });
};
